import { render, staticRenderFns } from "./ApexExtendedChart.vue?vue&type=template&id=5a458480"
import script from "./ApexExtendedChart.vue?vue&type=script&lang=js"
export * from "./ApexExtendedChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports